
(() => {
  const STORAGE_KEY = 'studioos-wishlist-v1';

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      return [];
    }
  };

  const write = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('studioos:wishlist-change', { detail: { items } }));
  };

  const escapeHTML = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  }[character]));

  const itemFromButton = (button) => ({
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || '',
    variantId: button.dataset.variantId || ''
  });

  const has = (handle) => read().some((item) => item.handle === handle);

  const syncButtons = () => {
    const items = read();
    const handles = new Set(items.map((item) => item.handle));

    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));

      const label = button.querySelector('span');
      if (label) label.textContent = saved ? 'Saved' : 'Save';
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((node) => {
      node.textContent = String(items.length);
    });
  };

  const render = () => {
    const items = read();
    const body = document.querySelector('[data-wishlist-items]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!body || !empty) return;

    body.innerHTML = items.map((item) => `
      <article class="sos-wishlist-item" data-wishlist-handle="${escapeHTML(item.handle)}">
        <a class="sos-wishlist-item__image" href="${escapeHTML(item.url)}">
          ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="sos-wishlist-item__content">
          <h3><a href="${escapeHTML(item.url)}">${escapeHTML(item.title)}</a></h3>
          <div class="sos-wishlist-item__price">${escapeHTML(item.price)}</div>
          <div class="sos-wishlist-item__actions">
            <a class="is-primary" href="${escapeHTML(item.url)}">View product</a>
            ${item.variantId ? `<button type="button" data-wishlist-add-cart="${escapeHTML(item.variantId)}">Add to cart</button>` : ''}
            <button type="button" data-wishlist-remove="${escapeHTML(item.handle)}">Remove</button>
          </div>
        </div>
      </article>
    `).join('');

    empty.classList.toggle('is-visible', items.length === 0);
    body.hidden = items.length === 0;
    document.querySelector('[data-wishlist-clear]')?.toggleAttribute('hidden', items.length === 0);

    syncButtons();
  };

  const open = () => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    render();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sos-wishlist-open');
  };

  const close = () => {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sos-wishlist-open');
  };

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const item = itemFromButton(toggle);
      const items = read();
      const index = items.findIndex((entry) => entry.handle === item.handle);

      if (index >= 0) items.splice(index, 1);
      else items.unshift(item);

      write(items);
      render();
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      open();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) {
      event.preventDefault();
      close();
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const handle = remove.dataset.wishlistRemove;
      write(read().filter((item) => item.handle !== handle));
      render();
      return;
    }

    if (event.target.closest('[data-wishlist-clear]')) {
      write([]);
      render();
      return;
    }

    const addCart = event.target.closest('[data-wishlist-add-cart]');
    if (addCart) {
      const original = addCart.textContent;
      addCart.disabled = true;
      addCart.textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(addCart.dataset.wishlistAddCart), quantity: 1 }]
          })
        });

        if (!response.ok) throw new Error('Unable to add product');
        addCart.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
          detail: { open: true, source: 'wishlist' }
        }));
      } catch {
        addCart.textContent = 'Try again';
      } finally {
        window.setTimeout(() => {
          addCart.disabled = false;
          addCart.textContent = original;
        }, 1400);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  window.addEventListener('storage', render);
  window.addEventListener('studioos:wishlist-change', render);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render, { once: true });
  } else {
    render();
  }

  document.addEventListener('shopify:section:load', render);
})();
